var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement } from '../typescript/TSXDomParse';
import { notNullAndLengthy } from '../typescript/helpers';
import LinkList from './LinkList';
import { headerContentType } from '../typescript/constants';
export default function NavMenuColumn(_a) {
    var components = _a.components, level = _a.level, clickFunction = _a.clickFunction, isMobile = _a.isMobile;
    return (DOMcreateElement("ul", { className: "children dropdown column-layout level-" + (level + 1) }, components.map(function (component) { return (DOMcreateElement(ChildLinkList, __assign({ component: component, level: level, isMobile: isMobile }, (clickFunction ? { clickFunction: clickFunction } : {})))); })));
}
function ChildLinkList(_a) {
    var _b, _c, _d, _e, _f, _g;
    var component = _a.component, clickFunction = _a.clickFunction, level = _a.level, isMobile = _a.isMobile;
    var isSidebar = (_d = ((_c = (_b = component.fields) === null || _b === void 0 ? void 0 : _b.menusidebaranme) === null || _c === void 0 ? void 0 : _c.length) > 0) !== null && _d !== void 0 ? _d : false;
    var parentHasChildren = notNullAndLengthy((_e = component.fields) === null || _e === void 0 ? void 0 : _e.components);
    var isNested = (_g = (_f = component.fields) === null || _f === void 0 ? void 0 : _f.components) === null || _g === void 0 ? void 0 : _g.some(function (c) {
        var _a, _b, _c;
        return ((_c = (_b = (_a = c.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id) === headerContentType;
    });
    var className = "level-" + (level + 1);
    className += isSidebar ? ' level-3-image-wrap' : ' divider';
    if (parentHasChildren) {
        className += ' has-children';
    }
    if (isNested)
        className += ' expandable';
    if (isMobile) {
        return (DOMcreateElement("div", { className: "dropdown-wrapper" },
            DOMcreateElement("li", { className: className },
                DOMcreateElement(LinkList, { isMobile: isMobile, component: component, level: level, clickFunction: clickFunction }))));
    }
    else {
        return (DOMcreateElement("li", { className: className },
            DOMcreateElement(LinkList, { isMobile: isMobile, component: component, level: level, clickFunction: clickFunction })));
    }
}
